module.exports = __webpack_public_path__ + "static/Panda2-d6533fa1d70007c8fdf6b0ae02256fdb.svg";